'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var APP = exports.APP = 'pricing-pages';

var SCREENS = exports.SCREENS = {
  PRODUCTS_PLANS: 'products-plans',
  CREATE_BUNDLE: 'create-bundle',
  GROWTH_SUITE: 'growth-suite',
  ERROR: 'error',
  CONTACT_CONFIRMATION: 'contact-confirmation',
  SUITE_CONTACT_CONFIRMATION: 'suite-contact-confirmation'
};

var SUBSCREENS = exports.SUBSCREENS = {
  MARKETING_HUB: 'marketing-hub',
  SALES_HUB: 'sales-hub',
  SERVICE_HUB: 'service-hub',
  CMS: 'cms',
  FREE_TOOLS_CRM: 'free-tools-crm'
};

var MERCH_CARD = exports.MERCH_CARD = 'merch-card';
var CALCULATOR = exports.CALCULATOR = 'calculator';
var SUITE_CARD = exports.SUITE_CARD = 'suite-card';
var SUITE_CALCULATOR = exports.SUITE_CALCULATOR = 'suite-calculator';
var CMS_CARD = exports.CMS_CARD = 'cms-card';


//////////////////
// WEBPACK FOOTER
// ./js/constants/Tracking.js
// module id = 41
// module chunks = 3 4